import React from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import core from '@gin-betting/core';

import { Odd, Portal } from 'components';
import { useMouseEventsHandler } from 'hooks';
import ui from 'modules/ui';
import UserDevice from 'services/user-device';
import useOddButton from './useOddButton';

const {
    components: { OddHistory },
} = ui;

const {
    entities: {
        components: { makeOddContainerFor },
    },
} = core;

const OddContainer = makeOddContainerFor<PropsFromReactComponent<typeof Odd>>();

interface Props {
    oddId: string;
    showResult?: boolean;
    withTitle?: boolean;
    modifyOddTitle?: (name: string) => string;
}

const OddButton: React.FC<Props> = props => {
    const { oddId, showResult, withTitle, modifyOddTitle } = props;

    const {
        betslipOddId,
        isSelected,
        oddFormat,
        statisticPercent,
        isShowStatistic,
        handleToggleOdd,
        isActive,
    } = useOddButton({ oddId });
    const { showHistory, onMouseEnter, onMouseLeave } = useMouseEventsHandler();

    return (
        <Manager>
            <Reference>
                {({ ref }) => (
                    <OddContainer
                        oddId={oddId}
                        component={Odd}
                        props={{
                            betslipOddId,
                            isSelected,
                            statisticPercent,
                            isShowStatistic,
                            oddFormat,
                            showResult,
                            toggleBetslipOdd: handleToggleOdd,
                            withTitle,
                            onMouseEnter,
                            onMouseLeave,
                            fRef: ref,
                            modifyOddTitle,
                        }}
                    />
                )}
            </Reference>
            {!UserDevice.getInstance()?.isDeviceMobile() &&
                isActive &&
                showHistory && (
                    <Portal isPageDisabled={false}>
                        <Popper
                            modifiers={{ arrow: { enabled: true } }}
                            placement="top"
                        >
                            {({ ref, style, arrowProps, placement }) => (
                                <OddHistory
                                    oddId={oddId}
                                    fRef={ref}
                                    style={style}
                                    arrowProps={arrowProps}
                                    placement={placement}
                                />
                            )}
                        </Popper>
                    </Portal>
                )}
        </Manager>
    );
};

export default OddButton;
